const itemsContainer = document.querySelector('.items__wrapper');
import data from './dataTab.js';

data.forEach((item, index) => {
    const newItem = document.createElement('div');
    newItem.classList.add('items__item');
    // newItem.setAttribute('data-aos', 'fade-up');
    newItem.setAttribute('data-category', `${item.category}`);
    newItem.setAttribute('data-index', index);
    const leftCol = document.createElement('div');
    leftCol.classList.add('items__item__left');

    const leftColHeading = document.createElement('h3');
    leftColHeading.textContent = `${index + 1}. ${item.name}`;
    leftCol.append(leftColHeading);

    const leftColDescription = document.createElement('p');
    leftColDescription.textContent = item.description;
    leftCol.append(leftColDescription);

    const technicalData = document.createElement('div');
    technicalData.classList.add('items__item__technical-data');

    const headingTechnicalData = document.createElement('p');
    headingTechnicalData.textContent = 'Dane Techniczne';
    technicalData.append(headingTechnicalData);

    const technicalList = document.createElement('ul');

    item.technical_data.forEach(element => {
        if (element.name.length > 0) {

            const liElement = document.createElement('li');
            liElement.textContent = `${element.name}: `;
            const liElementValue = document.createElement('strong');
            liElementValue.textContent = element.value;
            liElement.append(liElementValue);
            technicalList.append(liElement);
            leftCol.append(technicalList)
        }
    })

    const price = document.createElement('div');
    price.classList.add('items__item__price');

    const priceList = document.createElement('ul');
    const price1 = document.createElement('li');
    price1.innerHTML = `Cena: <strong>${item.price.rental_price}</strong>`;
    const price2 = document.createElement('li');
    price2.innerHTML = `Kaucja:<strong>${item.price.deposit}</strong>`;
    priceList.append(price1)
    priceList.append(price2)
    price.append(priceList);
    leftCol.append(price)
    newItem.append(leftCol)

    const rightCol = document.createElement('div');
    rightCol.classList.add('items__item__right');

    if (item.image) {
        const rightImg = document.createElement('img');
        rightImg.src = item.image instanceof URL ? item.image.href : item.image;
        rightImg.alt = item.name;
        rightCol.append(rightImg);
    } else {
        const noImg = document.createElement('div');
        noImg.classList.add('items__item__no-image');
        noImg.textContent = 'Brak zdjęcia';
        rightCol.append(noImg);
    }
    const rightCategory = document.createElement('p')
    rightCategory.innerHTML = `<strong>Kategoria:</strong> ${item.category}`;

    rightCol.append(rightCategory);
    rightCol.append(rightCategory);
    newItem.append(rightCol);

    itemsContainer.append(newItem);
});


const filterItems = (category) => {
    const items = document.querySelectorAll('.items__item');
    items.forEach((item) => {

        if (category === 'Wszystkie' || item.getAttribute('data-category') === category) {
            item.style.display = 'flex';
        } else {
            item.style.display = 'none';
        }
    });
    const activeLink = document.querySelector('.filters a.active');
    if (activeLink) {
        activeLink.classList.remove('active');
    }
    const selectedLink = document.querySelector(`.filters a[data-category="${category}"]`);
    selectedLink.classList.add('active');
    categories.forEach((category, index) => {

        if (index === categoriesArray.length - 1) {
            a.classList.add('bold');
        }

    });
};


const filters = document.querySelector('.filters');

const categories = new Set(data.map((item) => item.category));
categories.forEach((category) => {
    categories.add('Wszystkie');
    const categoriesArray = Array.from(categories);
    categoriesArray.unshift('Wszystkie');
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('href', '#');
    a.setAttribute('data-category', category);
    a.textContent = category;
    li.appendChild(a);
    filters.appendChild(li);

    a.addEventListener('click', (event) => {
        event.preventDefault();
        const category = event.target.getAttribute('data-category');

        filterItems(category);
    });
});

const links = document.querySelectorAll('.filters a');
const lastLink = links[links.length - 1];
lastLink.classList.add('active');
